import React, { memo } from "react";
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const AutoNumber = (props)=>{
  
  const {
    item,
    className,
    validationForms
  } = props;
  
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms); 
  
  return (
      <input 
        type="hidden"
        value={attr.value}
        {...attr.fieldAttributes} />
  );
}
AutoNumber.defaultProps = {
  generator: false,
  readOnly: false,
  className: "form-control",
}

const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item===nextProps.item){
    return true;
  }
}


export default memo(AutoNumber,isDiffProps);
